import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'cap-bsg-header',
  templateUrl: './cap-header.component.html',
  styleUrls: ['./cap-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent {

  @Input() appTitleKey: string;
  @Input() appLogo = "assets/logo.png";
  @Input() welcomePage = "/dashboard";
  toggleKey = "Close navigation";

  toggleHeader() {
    const e = document.body;
    if (e && e.classList) {
      let closed = e.classList.toggle('close-navigation');
      this.toggleKey = closed ? "Open navigation" : "Close navigation";
    }
  }
}
